import commonService from './commonService'
import utils from './utils'

const getAll = async (signal = null, axios_ = null) => {
  const url = utils.url + '/countries'
  return await commonService.load(url, signal, [], axios_)
}

const get = async (id, axios_ = null) => {
  const url = `${utils.url}/countries/${id}`
  return await commonService.load(url, null, null, axios_)
}

export default { getAll, get }
